module.exports = __webpack_public_path__ + "img/icon-check.ff849254.svg";